/**
 * UserTableHeader - Table header component for user table.
 *
 * Displays column headers for the user table.
 */

export function UserTableHeader() {
  return (
    <thead
      className="
        border-b border-border-default bg-bg-muted
        dark:bg-bg-subtle
      "
    >
      <tr>
        <th
          className="
            px-6 py-3 text-left text-xs font-medium tracking-wider text-text-muted uppercase
            dark:text-text-muted
          "
        >
          Email
        </th>
        <th
          className="
            px-6 py-3 text-left text-xs font-medium tracking-wider text-text-muted uppercase
            dark:text-text-muted
          "
        >
          Name
        </th>
        <th
          className="
            px-6 py-3 text-left text-xs font-medium tracking-wider text-text-muted uppercase
            dark:text-text-muted
          "
        >
          Admin
        </th>
        <th
          className="
            px-6 py-3 text-left text-xs font-medium tracking-wider text-text-muted uppercase
            dark:text-text-muted
          "
        >
          Expiry Date
        </th>
        <th
          className="
            px-6 py-3 text-left text-xs font-medium tracking-wider text-text-muted uppercase
            dark:text-text-muted
          "
        >
          Created
        </th>
        <th
          className="
            px-6 py-3 text-right text-xs font-medium tracking-wider text-text-muted uppercase
            dark:text-text-muted
          "
        >
          Actions
        </th>
      </tr>
    </thead>
  );
}
